module.exports = __webpack_public_path__ + "static/media/hang.dc3d1e60.png";